// Routes under /dashboard/*. The surrounding layout lives in AdminShell.
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import { FamilyDashboard } from "./Family/FamilyDashboard";
import { MemberDashboard } from "./Member/MemberDashboard";
import { DonationDashboard } from "./Donation/DonationDashboard";
import { Application } from "./Applicaton/Application";
import { Programs } from "./Programs/Programs";
import { FamilyDonation } from "./Family_Donation/FamilyDonation";
import { KwfDonation } from "./Kwf_Donation/KwfDonation";
import { AllGraph } from "./AllGraph/AllGraph";
import { FamilyProgram } from "./Programs/FamilyProgram";
import CaptureFingerprint from "./Fingerprint/CaptureFingerprint";
import Receipts from "./Receipts/Receipts";
import { MedicalStaff } from "./Medicalstaff/MedicalStaff";
import MonthlyReport from "./MonthlyReport/MonthlyReport";

import AppSection from "./admin/AppSection";
import BugReportDetail from "./admin/BugReportDetail";
import LicencesList from "./admin/LicencesList";
import LicenceDetail from "./admin/LicenceDetail";
import UsersList from "./admin/UsersList";
import UserDetail from "./admin/UserDetail";

const Dashboard = () => (
    <Routes>
      <Route index element={<AllGraph />} />
      <Route path="familydashboard" element={<FamilyDashboard />} />
      <Route path="memberdashboard" element={<MemberDashboard />} />
      <Route path="donationdashboard" element={<DonationDashboard />} />
      <Route path="applications" element={<Application />} />
      <Route path="program" element={<Programs />} />
      <Route path="familyProgram" element={<FamilyProgram />} />
      <Route path="family_donation" element={<FamilyDonation />} />
      <Route path="kwf_donation" element={<KwfDonation />} />
      <Route path="kwf_medical_staff" element={<MedicalStaff />} />
      <Route path="dashboard_graph" element={<AllGraph />} />
      <Route path="verify_fingerprint" element={<CaptureFingerprint />} />
      <Route path="kwf_receipts" element={<Receipts />} />
      <Route path="kwf_monthlyreport" element={<MonthlyReport />} />

      {/* Old /dashboard/ims duplicated /dashboard/admin/licences — redirect. */}
      <Route path="ims" element={<Navigate to="/dashboard/admin/licences" replace />} />

      {/* Admin (Django is_staff) section */}
      <Route path="admin" element={<Navigate to="app" replace />} />
      <Route path="admin/app" element={<AppSection />} />
      <Route path="admin/bug-reports/:id" element={<BugReportDetail />} />
      <Route path="admin/licences" element={<LicencesList />} />
      <Route path="admin/licences/:id" element={<LicenceDetail />} />
      <Route path="admin/users" element={<UsersList />} />
      <Route path="admin/users/:id" element={<UserDetail />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
);

export default Dashboard;
